<template>
  <v-dialog
    v-model="moveStrategyDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('projects.moveProject') }}</b>
      </v-card-title>
      
      <v-card-text class="mt-2">
        <v-flex
          xs12
          mt-5
          mb-5
        >
          {{ $t('projects.moveProjectDesc') }}
          <v-text-field
            v-model.trim="form.domain"
            autofocus
            class="mt-5 mb-5"
            prefix="https://"
            :label="$t('projects.domain')"
            :error-messages="DomainErrors"
            @blur="$v.form.domain.$touch()"
          />
        </v-flex>
        <v-flex>
          <v-checkbox
            v-model="form.confirm"
            color="primary"
          >
            <template
              v-slot:label
            >
              <small>
                {{ $t('projects.moveProjectConfirm') }}
              </small>
            </template>
          </v-checkbox>
        </v-flex>
      </v-card-text>
      <v-divider />
     
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="moveStrategyDialog = false"
        >
          <span>{{ $t('globals.cancelButton') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading || ($v.$invalid) || !form.confirm"
          :loading="loading"
          @click="moveStrategy()"
        >
          {{ $t('globals.saveButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import MOVE_STRATEGY_MUTATION from "@/graphql/mutations/MoveProject.gql";


import { validationMixin } from "vuelidate"
import { required, maxLength } from 'vuelidate/lib/validators';

const domain = domain =>{
  if (domain == null || domain == "") {
    return true;
  }
  const re = /^((http|https):\/\/)?[a-zа-я0-9]+([\-\.]{1}[a-zа-я0-9]+)*\.[a-zа-я]{2,10}(:[0-9]{1,5})?(\/.*)?$/i
  return re.test(domain);
}

export default {
  name: "MoveStrategyDialog",
  mixins: [validationMixin],
  props: {
    projectId: {
      type: String,
      default() {
        return null;
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        domain: null,
        confirm: false
      }
    };
  },
  computed: {
    moveStrategyDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeMoveStrategyDialog', false);
      }
    },
    rules() {
      var form = {
        domain: {
          required,
          domain,
          maxLength: maxLength(100),
        },
      };
      return form;
    },
    DomainErrors() {
      const errors = [];
      if (!this.$v.form.domain.$dirty) return errors;
      !this.$v.form.domain.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.domain.$params.maxLength.max}));
      !this.$v.form.domain.domain &&
        errors.push(this.$t("whitelabel.invalidUrl"));
      return errors;
    },
  },
  validations() {
    return {
      form: this.rules
    };
  },
  methods: {
    moveStrategy() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const params = {
        id: this.projectId,
        domain: this.form.domain,
        provider_uuid: this.$ls.get('config').uuid
      }
      this.$apollo
        .mutate({
          mutation: MOVE_STRATEGY_MUTATION,
          variables: params
        })
        .then(data => {
          this.loading = false;
          this.$emit('closeMoveStrategyDialog', true);
        })
        .catch(error => {
          this.loading = false;
          if (error.graphQLErrors[0].extensions.category == 'authorization' && error.graphQLErrors[0].message === "This action is unauthorized.") {
            this.$store.commit("app/setShowPermission");
            return;
          }
          this.errorHandler(error);
        });
    }
  }
};
</script>

<style lang="scss" >
</style>
